import { observable } from 'mobx';
import { DesignElementController } from 'cd-eft/services/eftSetApi';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

export interface IDataResponse {
  designElementId: number;
  designElementTypeId: number;
  json: string;
  projectId: string;
  sessionId: string;
  surveyprjId: string;
}

export class ElementContainerVM {
  @observable props;
  constructor(props: any) {
    this.props = props;
  }
}

// used in AlignmentSummaryTable
export const getListOfDesignElements = async (designElementId: string) => {
  try {
    // console.log('getListOfDesignElementsPAYPOAD', designElementId);
    const response = await DesignElementController.surveyDesignElementByIdUsingGET(designElementId);
    // console.log('getListOfDesignElementsRESPONSE', response);
    if (response.data) return response.data;
  } catch (error) {
    MessageCenter.addError((error as Error).message);
  }
};

// used in AlignmentContainer
export const deleteDesignElement = async (designElementId: number) => {
  try {
    // console.log('deleteDesignElementPAYPOAD', designElementId);
    const response = await DesignElementController.deleteDesignElementUsingPOST(designElementId);
    // console.log('deleteDesignElementRESPONSE', response);
    if (response.data) return response.data;
  } catch (error) {
    MessageCenter.addError((error as Error).message);
  }
};
